import React from 'react'

import style from "./SignupOrSeparator.module"

const SignupOrSeparator = () => {
    return <div className={style.separator}>
        <span className={style.text}>{I18n.t('or')}</span>
    </div>
}

export default SignupOrSeparator;
